module.exports = "<header class=\"portlet-header\">\n    <h2 class=\"portlet-title\" data-i18n=\"errorPage.offline.title\"></h2>\n</header>\n\n<div class=\"portlet-body padding-body scrollable\" dc-scrollbar>\n    <span data-i18n=\"errorPage.offline.message\"></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/ui/app/services/MaintenanceService/maintenanceDialog.tpl.html
// module id = 928
// module chunks = 12